import { render, staticRenderFns } from "./PaymentRemittanceViewHeader.vue?vue&type=template&id=3d6cba01&"
import script from "./PaymentRemittanceViewHeader.vue?vue&type=script&lang=js&"
export * from "./PaymentRemittanceViewHeader.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRemittanceViewHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports